import {
  Swiper,
  Navigation,
  Keyboard
} from 'swiper';

Swiper.use([Navigation, Keyboard]);

const sliderSections = document.querySelectorAll(".s-estates-slide");

sliderSections.forEach(slideSection => {
  const slider = slideSection.querySelector(".s-estates-slide__slider");
  const buttonPrev = slideSection.querySelector(".swiper-button-prev");
  const buttonNext = slideSection.querySelector(".swiper-button-next");

  const swiperSettings = {
    navigation: {
      nextEl: buttonNext,
      prevEl: buttonPrev,
    },
    keyboard: true,
    draggable: true,
    slidesPerView: 1,
    spaceBetween: 8,
    updateOnWindowResize: true,
    initialSlide: 0,
    breakpoints: {
      767: {
        slidesPerView: 2,
        spaceBetween: 16
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 16
      },
      1200: {
        slidesPerView: 3.5,
        spaceBetween: 16
      },
    }
  };

  new Swiper(slider, swiperSettings);
});
